import React from 'react';

/**
 * --- CHANGE LOG ---
 * - Changed the button container from `justify-end` to `justify-center` to horizontally center the buttons.
 * - Added 'cancelText' prop to allow customization of the cancel button's text.
 */
export default function ConfirmModal({ 
    isOpen, 
    onClose, 
    onConfirm, 
    onCancel,
    title, 
    message, 
    confirmText = 'Confirm', 
    cancelText = 'Cancel',
    showCheckbox = false,
    checkboxLabel = '',
    checkboxState = false,
    onCheckboxChange = () => {}
}) {
    const handleBackdropClick = (e) => {
        // Only close if clicking on the backdrop itself, not the modal content
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        } else {
            onClose();
        }
    };

    const handleCheckboxChange = (e) => {
        onCheckboxChange(e.target.checked);
    };

    const handleConfirm = () => {
        onConfirm();
    };

    if (!isOpen) return null;

    return (
        // Backdrop for the modal, which closes the modal on click
        <div 
            className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4"
            onMouseDown={handleBackdropClick}
        >
            {/* Modal content container */}
            <div 
                className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-xl animate-fade-in-up"
                onMouseDown={e => e.stopPropagation()} // Prevents closing when clicking inside the modal
            >
                <h2 className="text-xl font-semibold mb-4 text-gray-800">{title}</h2>
                <div className="text-gray-600 mb-6 whitespace-pre-line">{message}</div>
                
                {showCheckbox && (
                    <div className="mb-6">
                        <label className="flex items-center space-x-3 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={checkboxState}
                                onChange={handleCheckboxChange}
                                className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-gray-300 rounded"
                            />
                            <span className="text-sm text-gray-700">{checkboxLabel}</span>
                        </label>
                    </div>
                )}
                
                <div className="flex justify-end gap-4">
                    <button
                        type="button"
                        onClick={handleCancel}
                        className="px-4 py-2 rounded-md text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        className="px-4 py-2 rounded-md text-white bg-sky-500 hover:bg-sky-600 transition-colors"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}